import { render, staticRenderFns } from "./UiToast.vue?vue&type=template&id=7b4e25e8&"
import script from "./UiToast.vue?vue&type=script&lang=js&"
export * from "./UiToast.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports